import { atom } from "jotai";

export const currentClusterAtom = atom<{ id: number | undefined }>({
  id: undefined,
});
